import { OipfEngine } from '../../engines/oipf/oipf.engine';
import { HTML5Engine } from '../../engines/html5/html5.engine';
import { withOptions } from '../../engines/engine.utils';

export const getPlayerInstance = () => Promise.resolve({ Engine: OipfEngine });

export const getAdPlayerInstance = () =>
  Promise.resolve({ Engine: withOptions(HTML5Engine, { awaitCanPlayThrough: true }) });
